<div class="mm-container">
    <mm-spinner class="mm-spinner"></mm-spinner>
</div>
